"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchMultiCategoryEvents = fetchMultiCategoryEvents;
const fetchWithdrawV2Events_js_1 = require("./fetchWithdrawV2Events.js");
const fetchAutoCompoundingEvents_js_1 = require("./fetchAutoCompoundingEvents.js");
const fetchLiquidityChangeEvents_js_1 = require("./fetchLiquidityChangeEvents.js");
async function fetchMultiCategoryEvents(params) {
    const result = {};
    const { eventCategories, startTime, endTime, order } = params;
    const promises = eventCategories.map(async (category) => {
        switch (category) {
            case "AutoCompounding":
                result["AutoCompounding"] = await (0, fetchAutoCompoundingEvents_js_1.fetchAutoCompoundingEvents)({
                    startTime,
                    endTime,
                    order,
                });
                break;
            case "LiquidityChange":
                result["LiquidityChange"] = await (0, fetchLiquidityChangeEvents_js_1.fetchLiquidityChangeEvents)({
                    startTime,
                    endTime,
                    order,
                });
                break;
            case "WithdrawV2":
                result["WithdrawV2"] = await (0, fetchWithdrawV2Events_js_1.fetchWithdrawV2Events)({
                    startTime,
                    endTime,
                    order,
                });
                break;
            default:
                return Promise.reject(new Error(`Unsupported event category: ${category}`));
        }
    });
    await Promise.all(promises);
    return result;
}
//# sourceMappingURL=fetchMultiCategoryEvents.js.map